module.exports = require('./helpers/bundle-url').getBundleURL('3lIFQ') + "../img/sprite.385b51e3.svg";